import {getShopKey} from './exchange';
import {decryptAesKey, decryptPayload} from './ssl';

export const decryptPayloadD = async (encData: Object) => {
  const shopKeys = await getShopKey();
  const shopK = shopKeys.keyPair.privateKey;
  try {
    console.info('encData', encData);
    const key = await decryptAesKey(
      encData.encKey,
      shopK as JsonWebKey,
    );
    const {encryptedPayload, iv} = encData.payload;
    const userData = JSON.parse(
      await decryptPayload(
        key,
        encryptedPayload as string,
        iv as string,
      ),
    );
    return userData;
  } catch (err) {
    console.error(err);
  }
};
